import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=552a0e08&"
import script from "./collapse.vue?vue&type=script&lang=ts&"
export * from "./collapse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports